import React, { useState } from 'react';
import {
    TextField,
    Typography,
    Box, Stack,
} from '@mui/material';
import {ProposalResource} from "../../types/Proposal";
import { Delete } from '../common/Delete';
import {ImageViewer} from "./ImageViewer";
import { FileUpload } from "../form/FileUpload";
import { adaptImageData } from "../../utils/IngestorConverters";
import { useAuthStore } from "../../store/auth.store";

interface ProposalResourceExt extends ProposalResource {
    pseudoId?: number
    isNew?: boolean
}

const imageStyle = {
    height: '50px',
    maxWidth: '100px'
}


export function ProposalResourceControl ({setResources, resources, canEdit}:{
    setResources:(resources:ProposalResource[]) => void,
    resources:ProposalResource[]
    canEdit:boolean
}) {
    const {can} = useAuthStore();
    const [showImages, setShowImages] = useState(false);
    const [imageIndex, setImageIndex] = useState(0);

    const canManage = can('manage_proposals')

    const updateResource = (resource:ProposalResource) => {
        const newResources = [...resources];
        for(let i = 0; i < newResources.length; i++) {
            const compare = newResources[i];
            const pseudoId1 = (compare as ProposalResourceExt).pseudoId;
            const pseudoId2 = (resource as ProposalResourceExt).pseudoId;
            if((compare.id && resource.id && compare.id === resource.id) || (pseudoId1 && pseudoId2 && pseudoId1 === pseudoId2)) {
                newResources[i] = resource;
                setResources(newResources);
                break;
            }
        }
    }

    const deleteResource = (id:string, pseudoId?:number) => {
        setResources(resources.filter((res) =>
            res.id !== id
            || (
                (res as ProposalResourceExt).pseudoId
                &&
                (res as ProposalResourceExt).pseudoId !== pseudoId
            )));
    };

    return (
        <Box mb={4}>
            <Typography variant="h6" gutterBottom>
                Resources
            </Typography>
            <Stack gap={"15px"} className={"mb-15"}>
            {resources.map((resource, index) => (
                <Stack gap={"5px"} flexDirection={"row"} alignItems={"center"} key={resource.id || (resource as ProposalResourceExt).pseudoId}>

                    {/*<TextField
                            label="Type"
                            value={resource.type}
                            onChange={(e) => handleResourceChange(index, 'type', e.target.value)}
                            fullWidth
                        />*/}
                    {canManage && <TextField
                            label="Content"
                            disabled
                            value={resource.content}
                            onChange={(e) => {
                                updateResource({...resource, content: e.target.value})
                            }}
                            fullWidth
                        />}
                        {resource.content && <img alt={"source"} src={adaptImageData(resource.source, 'content', resource.content)} style={imageStyle} onClick={() => {
                            setImageIndex(index)
                            setShowImages(true)
                        }}/>}
                    {canEdit && <Delete onConfirm={() => deleteResource(resource.id, (resource as ProposalResourceExt).pseudoId)}/>}
                </Stack>
            ))}
            </Stack>
            {canEdit && <FileUpload
                label={"Upload Photo"}
                accept={".jpg,.jpeg,.png"}
                sublabel={"only JPG and PNG allowed"}
                onUpload={(fileInfo) => {
                    const res = [...resources, ({
                        isNew: true,
                        source: 'relapka',
                        pseudoId: Math.random(),
                        id: (null as unknown) as string,
                        type: 'image',
                        content: fileInfo.id
                    } as ProposalResourceExt)];
                    setResources(res);
                }}
            />}

            {showImages && <ImageViewer index={imageIndex} resources={resources} onClose={() => setShowImages(false)}/>}
        </Box>
    );
}